/* eslint-disable import/max-dependencies */
import React from "react";
import { useDispatch } from "react-redux";
import { useTable } from "@fas/ui-framework";

import { Link, useNavigate } from "react-router";
import {
  SelectSearchComponent, ShowMoreItems,
  Table,
} from "@fas/ui-core";
import type { Column } from "@fas/ui-core";
import ActionsMenu from "./ActionsMenu";
import { LINKING_LIST } from "../../helpers/constants";
import {
  getLinkingListSaga,
} from "../../actions/linkingList";
import { getHashValue } from "../../services/jusCan";
import type { LinkingInfo } from "../LinkingInfoForm/types/LinkingInfoForm.types";

function TypeSearchComponent(searchProps: any) {
  return (
    <SelectSearchComponent
      {...searchProps}
      values={[
        { value: "matrix", title: "Matrix" },
        { value: "list", title: "List" },
      ]}
    />
  );
}

function LinkingList() {
  const columns: Array<Column<LinkingInfo>> = [
    {
      field: "name",
      label: "Name",
      searchable: true,
      sortable: true,
      render: ({ id, name }) => (
        <Link to={`/linking/edit/${id}?hashId=${getHashValue()}`}>
          {name}
        </Link>
      ),
    },
    {
      field: "type",
      label: "Type",
      searchable: true,
      sortable: true,
      SearchComponent: TypeSearchComponent,
    },
    {
      field: "tagsGeneration",
      label: "Tags generation",
      searchable: false,
      sortable: false,
      render: (row) => (<ShowMoreItems data={row.tagsGeneration} />),
    },
    {
      field: "tagsDisplay",
      label: "Tags display",
      searchable: false,
      sortable: false,
      render: (row) => (<ShowMoreItems data={row.tagsDisplay} />),
    },
    {
      field: "updatedAt",
      label: "Updated at",
      searchable: false,
      sortable: true,
    },
    {
      field: "lastEditor",
      label: "Author",
      searchable: false,
      sortable: true,
    },
  ];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableProps = useTable<LinkingInfo>(LINKING_LIST);
  const onLoad = () => dispatch(getLinkingListSaga());

  const onCreate = () => navigate(`/linking/create?hashId=${getHashValue()}`);

  return (
    <Table
      {...tableProps}
      columns={columns}
      title="Linking list"
      onLoad={onLoad}
      onCreate={onCreate}
      rowSelectAvailable={() => true}
      allSelectAvailable={() => true}
      Actions={<ActionsMenu />}
    />
  );
}

export default LinkingList;
